import React from 'react';
import Box from '@amzn/meridian/box';
import Heading from '@amzn/meridian/heading';
import MetricCard from '../MetricCard';
import './ShiftTotalsSection.scss';
import { EnhancedShiftTotals } from '../../pages/reviewAndPublish/model';

export interface ShiftTotalsSectionStateProps {
  shiftTotals?: EnhancedShiftTotals;
}

const ShiftTotalsSection: React.FC<ShiftTotalsSectionStateProps> = ({ shiftTotals }) => {
  return (
    <Box className="shift-totals-section">
      <Heading type="h300" level={1} className="shift-totals-section__title">
        Shift totals
      </Heading>

      <Box className="shift-totals-section__grid">
        <MetricCard
          title={'VET Accepted'}
          value={shiftTotals?.vetAcceptedHours?.intValue ?? '--'}
          unit={'hours'}
          className="shift-totals-section__card"
          size="small"
        />
        <MetricCard
          title={'Ready Accepted'}
          value={shiftTotals?.amazonReadyAcceptedHours?.intValue ?? '--'}
          unit={'hours'}
          className="shift-totals-section__card"
          size="small"
        />
        <MetricCard
          title={'VTO Accepted'}
          value={shiftTotals?.vtoAcceptedHours?.intValue ?? '--'}
          unit={'hours'}
          className="shift-totals-section__card"
          size="small"
        />
      </Box>
    </Box>
  );
};

export default ShiftTotalsSection;